import { cancellationSelectorsFactory } from 'state/secondaryMarket/shared/cancellation/cancellationSelectorsFactory';

export const limitOrderCancellationSelectors = cancellationSelectorsFactory('limitOrder');
